import { PwaManager, PwaInstall, OfflineQueue, showError } from '@modernman00/shared-js-lib';

// 1. Service Worker & Update Toast
PwaManager.init({
    swUrl: '/sw.js',
    appName: 'iAccount',
    onUpdateAvailable: (worker) => {
        if (typeof showUpdateToast === 'function') showUpdateToast(worker);
    }
});

// 2. Idempotent Offline Queue
window.offlineQueue = new OfflineQueue({ appName: 'iaccountapp' });

// 3. Smart Install Banner (Emerald FinTech Brand Color)
new PwaInstall({
    appName: 'iAccount',
    appIcon: '/public/images/logo-512.png',
    brandColor: '#052e96ff',
    dismissDays: 14
});
import './chat.js'; // Global AI Chat Agent

document.addEventListener('DOMContentLoaded', () => {
  const routeMap = {
    '/': () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
    '/dashboard': () => import(/* webpackChunkName: 'dashboard' */ './dashboard'),
    '/upload': () => import(/* webpackChunkName: 'upload' */ './upload'),
    // login and register routes will be loaded from the auth.js file
    '/login': () => import(/* webpackChunkName: 'login' */ './login'),
    '/register': () => import(/* webpackChunkName: 'register' */ './register'),
    '/forgot': () => import(/* webpackChunkName: 'forgotPwd' */ './forgotPwd'),
    '/reset-password': () => import(/* webpackChunkName: 'resetPwd' */ './resetPwd'),
    '/code': () => import(/* webpackChunkName: 'code' */ './code')
  };

  const path = window.location.pathname;
  try {
    const loadModule = routeMap[path];

    if (loadModule) {
      loadModule()
        .then((module) => {
          if (module.default) module.default();
        })
        .catch((err) => {
          showError(err);
        });
    }
  } catch (error) {
    showError(error);
  }
});


